import React from 'react';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';

import {PageService} from 'units/constructor-local/models';
import ServiceLogo from 'units/constructor-local/components/ServiceLogo/ServiceLogo';

import './ServiceLabel.scss';

const b = block('service-label-block');

interface ServiceLabelProps extends Pick<PageService, 'name' | 'slug'> {
    inline?: boolean;
    size?: 's' | 'm' | 'l';
    className?: string;
    icon?: string | null;
}

const ServiceLabel: React.FC<ServiceLabelProps> = ({
    name,
    slug,
    icon,
    inline = false,
    size = 'l',
    className,
}) => (
    <div className={b({size, inline}, className)}>
        <ServiceLogo className={b('logo')} service={slug} size={size} icon={icon} />
        {React.createElement(
            size === 's' ? 'span' : 'h5',
            {className: b('name')},
            <HTML>{name}</HTML>,
        )}
    </div>
);

export default ServiceLabel;
